import {UIDHeaderController} from '../../../ui_html/header/UIDHeaderController'
import {UIWHeaderController} from '../../../ui_html/header/UIWHeaderController'
import {UIDFooterController} from '../../../ui_html/UIDFooterController'
import {UIWFooterController} from '../../../ui_html/UIWFooterController'

export class UIDTermsSceneController {
    private readonly headerController: UIWHeaderController
    private readonly footerController: UIWFooterController
    private readonly termsSceneContainerDiv: HTMLDivElement

    constructor(headerController: UIWHeaderController, footerController: UIWFooterController) {
        this.headerController = headerController
        this.footerController = footerController
        this.termsSceneContainerDiv = document.getElementById('scene_discord_terms_container') as HTMLDivElement
    }

    hide() {
        this.termsSceneContainerDiv.classList.add('hidden')
    }

    show() {
        this.termsSceneContainerDiv.classList.remove('hidden')

        if(this.headerController instanceof UIDHeaderController) this.headerController.deactivateAllButtons()
        if(this.footerController instanceof UIDFooterController) this.footerController.deactivateAllButtons()
    }
}
